var map = {
	"./en/realtimePage": 32677,
	"./es/realtimePage": 41808,
	"./fr/realtimePage": 39724,
	"./hn/realtimePage": 62282,
	"./pb/realtimePage": 22134,
	"./rs/realtimePage": 7889
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97834;